import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function SEO({ title, description, isHome = false }) {
  const siteTitle = isHome ? 'Insightly Care' : `${title} - Insightly Care`
  const defaultDesc =
    'Insightly Care hjælper virksomheder med professionel IT & Tech Recruitment. Birgitte Vilsgaard matcher virksomheder med de rette specialister gennem personlig og specialiseret rekruttering.'

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description || defaultDesc} />
      <meta property="og:type" content="website" />
    </Helmet>
  )
}
